import Api from '../api';

export interface ListUpdatesParams {
  kind?: string;
  card_id?: number;
  read?: boolean;
  page?: number;
  per_page?: number;
}

export const listUpdates = (params: ListUpdatesParams = {}) =>
  Api.get('/gestao_ia/atualizacoes', { params });

export const getUnreadUpdatesCount = () => Api.get('/gestao_ia/atualizacoes/nao_lidas');

export const markUpdatesRead = (updateIds: number[]) =>
  Api.patch('/gestao_ia/atualizacoes/marcar_lidas', { update_ids: updateIds });

export const markUpdatesUnread = (updateIds: number[]) =>
  Api.patch('/gestao_ia/atualizacoes/marcar_nao_lidas', { update_ids: updateIds });

export const dismissUpdates = (updateIds: number[]) =>
  Api.patch('/gestao_ia/atualizacoes/excluir', { update_ids: updateIds });

export const markAllUpdatesRead = () => Api.patch('/gestao_ia/atualizacoes/marcar_todas_lidas');
